import React from 'react';

function RouteLoadingState() {
  return (
    <section
      className="route-loading"
      role="status"
      aria-busy="true"
      aria-live="polite"
    >
      <span className="route-loading__indicator" aria-hidden="true" />
      <p className="route-loading__eyebrow">Navigation</p>
      <h1>Loading page</h1>
      <p className="route-loading__message">
        Preparing the requested page.
      </p>
    </section>
  );
}

export default RouteLoadingState;
